import * as Sentry from '@sentry/browser';

import { DEBUG_MODE } from './spdConfig';

declare const process: { env: { BUILD_VERSION: string; SENTRY_DSN: string } };

const isProduction = !DEBUG_MODE;

Sentry.init({
  dsn: process.env.SENTRY_DSN,
  release: process.env.BUILD_VERSION,
  environment: isProduction ? 'production' : 'development',
  enableLogs: false,

  sendDefaultPii: false,
  attachStacktrace: true,
  maxBreadcrumbs: 100,
  tracesSampleRate: 0.01,

  integrations: [Sentry.browserTracingIntegration()],

  beforeSend(event) {
    const monitor = (
      window as unknown as {
        supervisorMonitor?: { getSurveyInformation(): unknown };
      }
    ).supervisorMonitor;
    if (monitor) {
      event.contexts = {
        ...event.contexts,
        supervisorMonitor: monitor.getSurveyInformation() as Record<
          string,
          unknown
        >,
      };
    }
    return event;
  },
});
